<template>
  <SiteLink
    v-if="$content.options.value.navigation?.main?.cards[0]"
    :content="{ link: $content.options.value.navigation.main.cards[0].link }"
    class="flex items-center text-sm group"
  >
    <IconSprite
      id="symbol"
      class="text-pink group-hover:text-burgundy text-[50px] -mr-[25px] transition-colors"
    />
    <span class="uppercase leading-0 group-hover:text-pink transition-colors">
      {{ $content.options.value.navigation?.main?.cards[0].label }}
    </span>
  </SiteLink>
</template>

<script lang="ts">
import IconSprite from '@/components/helpers/IconSprite.vue'
import SiteLink from '@/components/helpers/SiteLink.vue'

export default {
  name: 'CardLink',
  components: { IconSprite, SiteLink },
}
</script>
